import { memo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import useAuth from '@/hooks/useAuth';
import { useClientQuery } from '@/hooks/useClientQuery';
import { IbDeskGateway } from '@/providers/IbDeskGateway';
import { embedEntryPath } from '@/utils/b2coreEmbed';
import Spinner from './Spinner';

const EmbedLayout = memo(function EmbedLayout() {
  const clientQuery = useClientQuery();

  if (clientQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <IbDeskGateway currentClient={clientQuery.data}>
      <div className="flex min-h-svh w-full flex-col">
        <Outlet />
      </div>
    </IbDeskGateway>
  );
});

const EmbedRoute = memo(function EmbedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={embedEntryPath(location.pathname + location.search)} replace />;
  }

  return <EmbedLayout />;
});

export default EmbedRoute;
